import { inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { injectTranslate } from '@core/i18n-legacy';
import { TellentSkillsDataFacade } from '@core/tellent-skills-logic';
import { NotificationsController } from '@core/user-interface-legacy';

@Injectable()
export class PositionDetailsSkillsNotificationsService {
  private readonly skillsFacade = inject(TellentSkillsDataFacade);
  private readonly notificationsController = inject(NotificationsController);
  private readonly t = injectTranslate();

  constructor() {
    const notify = (key: string) => this.notificationsController.success(this.t(key));
    const destroyed = takeUntilDestroyed();

    this.skillsFacade.assignSkillSuccess$
      .pipe(destroyed)
      .subscribe(() =>
        notify('tlc.positions.position_details_dialog.tabs.skills.notifications.skill_added'),
      );

    this.skillsFacade.assignSkillMappingSuccess$
      .pipe(destroyed)
      .subscribe(() =>
        notify(
          'tlc.positions.position_details_dialog.tabs.skills.notifications.skill_mapping_assigned',
        ),
      );

    this.skillsFacade.updateSkillSuccess$
      .pipe(destroyed)
      .subscribe(() =>
        notify(
          'tlc.positions.position_details_dialog.tabs.skills.notifications.proficiency_updated',
        ),
      );

    this.skillsFacade.unassignSkillSuccess$
      .pipe(destroyed)
      .subscribe(() =>
        notify('tlc.positions.position_details_dialog.tabs.skills.notifications.skill_unassigned'),
      );

    this.skillsFacade.unassignSkillMappingSuccess$
      .pipe(destroyed)
      .subscribe(() =>
        notify(
          'tlc.positions.position_details_dialog.tabs.skills.notifications.skill_mapping_unassigned',
        ),
      );
  }
}
